export type MeticulousFlagOverride = {
  overridden?: boolean;
  value?: unknown;
};

type ResolveDogfoodFlagDeps<T> = {
  readOverride: () => MeticulousFlagOverride | undefined;
  record: (flagKey: string, value: string | boolean) => void;
  evaluate: (defaultValue: T) => T;
};

export function resolveDogfoodFlag<T>(flagKey: string, defaultValue: T, deps: ResolveDogfoodFlagDeps<T>): T {
  let override: MeticulousFlagOverride | undefined;
  try {
    override = deps.readOverride();
  } catch {
    override = undefined;
  }

  if (override?.overridden === true && isMeticulousVariation(defaultValue, override.value)) {
    try {
      deps.record(flagKey, override.value);
    } catch {
      return override.value;
    }
    return override.value;
  }

  try {
    return deps.evaluate(defaultValue);
  } catch {
    return defaultValue;
  }
}

function isMeticulousVariation<T>(defaultValue: T, value: unknown): value is T & (string | boolean) {
  return (
    (typeof defaultValue === 'boolean' || typeof defaultValue === 'string') && typeof value === typeof defaultValue
  );
}
